document.addEventListener('DOMContentLoaded', initLocatorInputs);
document.addEventListener('shopify:section:load', initLocatorInputs);

function initLocatorInputs() {
  document.querySelectorAll('[data-locator-input-wrapper]').forEach((wrapper) => {
    const input = wrapper.querySelector('[data-locator-input]');
    const checkbox = wrapper.querySelector('[data-locator-checkbox]');
    const submit = wrapper.querySelector('[data-locator-submit]');

    if (!input || !submit) return;

    input.addEventListener('keyup', () => {
      wrapper.classList.toggle('letter-added', input.value.length > 0);
    });

    function handleSubmit(event) {
      event.preventDefault();

      const url = submit.getAttribute('data-locator-url');
      if (!url) return;

      if (input.value.length === 0) {
        wrapper.classList.add('is-error');
        return;
      }

      let href = `${url}?location=${encodeURIComponent(input.value)}`;

      if (checkbox) {
        const extraParam = checkbox.getAttribute('data-param-add');
        if (extraParam) href += `&${extraParam}`;
      }

      window.location.href = href;
    }

    input.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') handleSubmit(e);
    });

    submit.addEventListener('click', handleSubmit);
  });
}
